import {
  customInstance
} from "./chunk-PXAHF6KP.js";

// generated/search-bff/controllers/search-alert/search-alert.ts
var editSearchAlert = (searchAlertId, editSearchAlertRequest, options) => {
  return customInstance(
    {
      url: `/api/v4/searchalert/alert/${searchAlertId}`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: editSearchAlertRequest
    },
    options
  );
};
var deleteSearchAlert = (searchAlertId, options) => {
  return customInstance(
    {
      url: `/api/v4/searchalert/alert/${searchAlertId}`,
      method: "DELETE"
    },
    options
  );
};
var findAllSearchAlerts = (params, options) => {
  return customInstance(
    {
      url: `/api/v4/searchalert/alert`,
      method: "GET",
      params
    },
    options
  );
};
var createSearchAlert = (createSearchAlertV4Request, options) => {
  return customInstance(
    {
      url: `/api/v4/searchalert/alert`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createSearchAlertV4Request
    },
    options
  );
};
var deleteAllSearchAlerts = (options) => {
  return customInstance(
    {
      url: `/api/v4/searchalert/alert`,
      method: "DELETE"
    },
    options
  );
};
var getSearchAlertForDisplayLegacy = (searchAlertId, params, options) => {
  return customInstance(
    {
      url: `/api/v4/searchalert/unauth/alert/${searchAlertId}`,
      method: "GET",
      params
    },
    options
  );
};
var deleteSearchAlertPublic = (searchAlertId, params, options) => {
  return customInstance(
    {
      url: `/api/v4/searchalert/unauth/alert/${searchAlertId}`,
      method: "DELETE",
      params
    },
    options
  );
};

export {
  editSearchAlert,
  deleteSearchAlert,
  findAllSearchAlerts,
  createSearchAlert,
  deleteAllSearchAlerts,
  getSearchAlertForDisplayLegacy,
  deleteSearchAlertPublic
};
